import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  HostListener,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { SpinnerComponent } from '@modules/shared/spinner/spinner.component';
import { capitalize } from '@pixacare/shared';
import { getZonesLabel, TopocareModelId, Zone } from '@pixacare/topocare-core';
import { TuiButton, TuiDialogContext } from '@taiga-ui/core';
import { POLYMORPHEUS_CONTEXT } from '@taiga-ui/polymorpheus';
import { TopocareModuleComponentInputs, TopocareModuleComponentOutputs } from '../models/topocare-module-component';
import { TopocareLoaderService } from '../services/topocare-loader.service';

@Component({
  selector: 'pxc-topocare-wrapper',
  templateUrl: './topocare-wrapper.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [TranslocoDirective, TuiButton, SpinnerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'h-[80vh] flex flex-col gap-4' },
})
export class TopocareWrapperComponent implements OnInit {
  private readonly topocareLoader = inject(TopocareLoaderService);
  private readonly context =
    inject<TuiDialogContext<TopocareModuleComponentOutputs, TopocareModuleComponentInputs>>(POLYMORPHEUS_CONTEXT);

  protected readonly availableModelIds: TopocareModelId[] = ['male-default'];
  protected readonly isTopocareReady = signal(false);

  protected readonly localizationControl = new FormControl(null, [Validators.required]);

  async ngOnInit(): Promise<void> {
    await this.topocareLoader.load();
    this.isTopocareReady.set(true);
  }

  @HostListener('wheel', ['$event'])
  @HostListener('mousedown', ['$event'])
  blockEvent(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
  }

  onZoneSelectionChange(zones: Zone[]): void {
    this.localizationControl.setValue(capitalize(getZonesLabel(zones)));
  }

  cancel(): void {
    this.context.completeWith(null);
  }

  confirm(): void {
    this.context.completeWith({
      localization: this.localizationControl.value,
    });
  }
}
